import React, {FC, MouseEvent, useCallback} from 'react';
import classNames from 'classnames';
import {ButtonNew} from 'components/ButtonNew';
import {IProductShort} from 'modules/products/types';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {useIsWorker} from 'core/hooks/useIsWorker';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';
import {useReservationFlow} from 'modules/product-snippet/components/ProductSnippetContainer/hooks/useReservationFlow';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import {plural} from 'core/helpers';
import style from './style.module.scss';

interface IProps extends IProductShort {
    className?: string;
    reservationClassName?: string;
}

export const InStoreButton: FC<IProps> = ({className, reservationClassName, ...product}) => {
    const isPrive = useIsPrive();
    const isWorker = useIsWorker();
    const isLoggedIn = useIsLoggedIn();

    const {reserveButtonText, onReserve, isReservationFlowActive, storesWithStockCount} = useReservationFlow({
        productData: product,
        isPrive,
        isWorker,
        isLoggedIn,
        availability: 'FOR_RESERVATION',
    });

    const winestoresText = plural(storesWithStockCount, ['винотеке', 'винотеках', 'винотеках']);
    const showsReservationInfo = isReservationFlowActive && 0 < storesWithStockCount;

    // href нужен только как семантическая ссылка на товар (SEO/фолбэк) — клик открывает
    // флоу бронирования, а не переходит на PDP
    const handleClick = useCallback(
        (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            e.preventDefault();
            onReserve();
        },
        [onReserve],
    );

    return (
        <div className={classNames(style.root, className)}>
            {showsReservationInfo && (
                <>
                    <div className={classNames(style.overlayPlaceholder, 'reservationOverlayPlaceholder')} />
                    <div className={classNames(style.winestoreCounter, 'reservationWinestoreCounter')}>
                        <Icon icon={'Express'} className={style.expressIcon} />
                        <Typography variant={'label-12-r'}>
                            Только в {storesWithStockCount} {winestoresText}
                        </Typography>
                    </div>
                </>
            )}
            <ButtonNew
                className={style.button}
                href={product.url}
                isStretched={true}
                variants={{DT: 'medium', TB: 'medium', MB: 'small'}}
                onClick={handleClick}
            >
                {reserveButtonText}
            </ButtonNew>
        </div>
    );
};
